// Período da TPARCOM (frota.parcom): emissão = Digitação NFs Compra, recebimento = Período para Compras
export interface PeriodoCompras { pa5enfdti: string | null; pa5enfdtf: string | null; pa5comdti: string | null; pa5comdtf: string | null }

// Data fora de [ini, fim] → mensagem com as datas em dd/mm/aaaa; '' se está dentro ou não há período
export function foraDoPeriodo(data: string, ini: string | null, fim: string | null, texto: string) {
  if (!data || (!ini && !fim)) return ''
  const br = (iso: string) => iso.split('-').reverse().join('/')
  return (ini && data < ini) || (fim && data > fim) ? `${texto} (${ini ? br(ini) : '...'} a ${fim ? br(fim) : '...'})` : ''
}

export function avisosPeriodo(p: PeriodoCompras | null, dataEmissao: string, dataRecebimento: string) {
  if (!p) return { emissao: '', recebimento: '' }
  return {
    emissao: foraDoPeriodo(dataEmissao, p.pa5enfdti, p.pa5enfdtf, 'Data de emissão fora do período permitido para emissão'),
    recebimento: foraDoPeriodo(dataRecebimento, p.pa5comdti, p.pa5comdtf, 'Data de recebimento fora do período de compras'),
  }
}
